import * as React from 'react';

import {UsageFooter} from 'shells/navigation/secondary-sidebar/usage-footer-new';

import {useGetContextDocumentUsage} from '../../inbox/chat/graphql/hooks/use-get-context-document-usage';

const APPROACHING_LIMIT_PERCENT = 0.9;

function getTooltipText(webPages: number, pdfs: number): string {
    const hasNoContent = webPages === 0 && pdfs === 0;
    if (hasNoContent) {
        return 'You haven’t added any content yet. Train your chatbot here.';
    }

    return `You’ve added ${webPages} web page${webPages === 1 ? '' : 's'} and ${pdfs} PDF${
        pdfs === 1 ? '' : 's'
    }`;
}

function getMessage(usage: number, limit: number): string {
    const hasNoContent = usage === 0;
    const belowRecommended = usage > 0 && usage < 5000;
    const usagePercent = limit ? usage / limit : 0;

    if (hasNoContent) {
        return 'Add pages from your website or PDFs to teach the chatbot how to talk about your company.';
    } else if (belowRecommended) {
        return 'We recommend at least 5,000 words of content to teach the chatbot. Add a few more pages.';
    } else if (usagePercent < 0.9) {
        return `Nice! You’ve got ${usage.toLocaleString()} words of content to train your chatbot.`;
    } else if (usagePercent < 1) {
        return `You’re approaching the content limit. Chatbot works best with less than 75,000 words of training.`;
    } else {
        return `You’re over the content limit. Remove some pages for a smarter chatbot.`;
    }
}

export function ContextDocumentsLimitFooter() {
    const {contextDocumentUsage} = useGetContextDocumentUsage();

    if (!contextDocumentUsage) {
        return null;
    }

    const limit = contextDocumentUsage.wordsLimit;
    const usage = contextDocumentUsage.wordsUsage;
    const webPages = contextDocumentUsage.webPagesUsage;
    const pdfs = contextDocumentUsage.pdfsUsage;

    const message = getMessage(usage, limit);
    const tooltipText = getTooltipText(webPages, pdfs);

    return (
        <UsageFooter
            type='contextDocuments'
            usage={usage}
            limit={limit}
            approachingLimitPercent={APPROACHING_LIMIT_PERCENT}
            message={message}
            hideUpgradeCta={true}
            progressTooltipText={tooltipText}
        />
    );
}
